(() => {
  const popularSections = qsa('.js-popular-posts');
  if(popularSections) {
    popularSections.forEach(item => {
      const sectionID = item.dataset.sectionId;
      new Swiper(`.js-popular-posts-swiper-${sectionID}`, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        init: true,
        slidesOffsetBefore: 12,
        slidesOffsetAfter: 12,
        watchOverflow: true,
        breakpoints: {
          990: {
            spaceBetween: 0
          }
        },
        pagination: {
          el: `.js-popular-posts-pagination-${sectionID}`,
          type: "progressbar",
        },
        navigation: {
          nextEl: `.js-popular-posts__swiper-next-${sectionID}`,
          prevEl: `.js-popular-posts__swiper-prev-${sectionID}`,
        }
      })
    })
  }
})();